export const createAutomationFixedCacheKey = "createAutomationFixedCacheKey";
export const updateAutomationFixedCacheKey = "updateAutomationFixedCacheKey";
